<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-3">
    <label for="r007_order">Pedido</label>
    <input id="r007_order" type="number" pInputText [(ngModel)]="filters.order"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_code">Código</label>
    <input id="r007_code" type="text" pInputText [(ngModel)]="filters.code"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_owner">Responsável</label>
    <input id="r007_owner" type="text" pInputText [(ngModel)]="filters.owner"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_enrollment">Matrícula</label>
    <input id="r007_enrollment" type="text" pInputText [(ngModel)]="filters.enrollment"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_state">UF</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r007_state" [options]="comboOptions.state" [(ngModel)]="filters.state" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_approved">Aprovado</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r007_approved" [options]="comboOptions.approved" [(ngModel)]="filters.approved"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_problem">Problema</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r007_problem" [options]="comboOptions.problem" [(ngModel)]="filters.problem"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_problemKind">Tipo do problema</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r007_problemKind" [options]="comboOptions.problemKind" [(ngModel)]="filters.problemKind"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_problemOther">Outro</label>
    <input id="r007_problemOther" type="text" pInputText [(ngModel)]="filters.problemOther"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r007_problemDetail">Detalhe</label>
    <input id="r007_problemDetail" type="text" pInputText [(ngModel)]="filters.problemDetail"/>
  </div>
</div>
